var render = function render(){var _vm=this,_c=_vm._self._c;return _c('oz-toggle',{attrs:{"isTooltipActive":"","tooltipText":"A DataZAP+ comprova que o preço destes anúncios está abaixo do valor de mercado.","initialValue":_vm.initialValue,"is-pill":_vm.isPill,"title":"Preço abaixo do mercado"},on:{"filters:update":_vm.updateDatazap}})
}
var staticRenderFns = []

export { render, staticRenderFns }